import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_ID;

export const initGA = () => {
  if (!GA_ID) return;
  ReactGA.initialize(GA_ID);
};

export const trackPageView = (path) => {
  if (!GA_ID) return;
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (action, params = {}) => {
  if (!GA_ID) return;
  ReactGA.event(action, params);
};
